import React, {Component} from 'react'
import CheckBoxItem from './CheckBoxItem'
import RadioGroup from './RadioGroup';

export default ({onToggle, data, active, id, radioData, questionNumber, radioManageFormData, prepop}) => {
  return (
    <CheckBoxItem
      onToggle={onToggle}
      data={data}
      active={active}
      id={id}
    >
      {!active ? null : (
        <RadioGroup
          data={radioData}
          questionNumber={questionNumber}
          manageFormData={radioManageFormData}
          secondaryQuestion={true}
          prepop={prepop}
        />
      )}
    </CheckBoxItem>
  )
}
